import React from "react";
import { Button } from "primereact/button";

const RenderTooltipCustom = (value, length = 100, position = "top") => {
  return value && value.length >= length ? (
    <>
      {value.substr(0, length)}
      <Button
        className="p-button-sm p-button-text"
        style={{
          padding: "0px 20px 0px 8px",
          color: "black",
          boxShadow: "none",
          backgroundColor: "transparent",
          border: "none",
        }}
        tooltip={value}
        tooltipOptions={{ position: `${position}` }}
      >
        ( <i className="fa fa-ellipsis-h" aria-hidden="true"></i> )
      </Button>
    </>
  ) : (
    value
  );
};

export default RenderTooltipCustom;
